import moment from 'moment-timezone';

import { FileLink } from '@models/file-link.model';
import { FileNotification } from '@models/notification/file-notification.model';
import { InvoiceNotification } from '@models/notification/invoice-notification.model';
import { ThreadNotification } from '@models/notification/thread-notification.model';
import { WattsonNotification } from '@models/notification/wattson-notification.model';
import { NotificationCategory } from '@models/types/notification-category';
import { NotificationEventType } from '@models/types/notification-event-type';
import { NotificationPriority } from '@models/types/notification-priority';
import { NotificationStatus } from '@models/types/notification-status';

import { AccountAdapter } from './account.adapter';
import { ApiAdapter } from './adapter';
import { InvoiceAdapter } from './invoice.adapter';
import { ThreadAdapter } from './thread.adapter';

export class NotificationAdapter extends ApiAdapter<WattsonNotification> {
  private accountAdapter = new AccountAdapter();
  private invoiceAdapter = new InvoiceAdapter();
  private threadAdapter = new ThreadAdapter();

  get(json): WattsonNotification {
    let classNotification;
    let adapter;
    switch (NotificationCategory[json['attachment_type']]) {
      case NotificationCategory.thread: {
        classNotification = ThreadNotification;
        adapter = this.threadAdapter;
        break;
      }
      case NotificationCategory.invoice: {
        classNotification = InvoiceNotification;
        adapter = this.invoiceAdapter;
        break;
      }
      case NotificationCategory.file: {
        classNotification = FileNotification;
        adapter = {
          get: (attachementJson) =>
            new FileLink({
              name: 'Export.xlsx',
              path: attachementJson['href'],
            }),
        };
        break;
      }
    }
    const events = Object.fromEntries(Object.entries(NotificationEventType).map(([key, value]) => [value, key]));
    return new classNotification({
      id: json['id'] || json['_id'],
      // TODO #API we use a filter for now, because the backend sends a {id: null, name: null} for File Notification
      accounts: this.accountAdapter.list(json['accounts'].filter((account) => account.id)),
      sentByBot: json['sent_by_bot'],
      category: NotificationCategory[json['attachment_type']],
      eventType: events[json['event_type']] ? json['event_type'] : undefined,
      createdAt: moment.tz(json['creation_date'], moment.tz.guess()),
      priority: NotificationPriority[json['priority']],
      status: NotificationStatus[json['status']],
      target: adapter.get(json['attachment']),
    });
  }
}
